import { colors } from 'kaizen-ui-colors/lib';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import styled, { StyledFunction } from 'styled-components';
import Card from './base/Card';
import Organization from '../../domain/entity/Organization';
import { IStore } from '../../domain/store/IStore';
import { IUsecase } from '../../application/usecase/IUsecase';
import CircularProgress from './base/CircularProgress';

interface IProps {
  store?: IStore;
  usecase?: IUsecase;
}

const CircularProgressWrapper = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 167px);
`;

const Wrapper = styled.div`
  margin: 0 0;
  padding: 0 0;
`;

const OrganizationCard = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border-radius: 2px;
  padding: 12px 8px;
  background-color: #fff;
  box-shadow: inset 0 -1px 0 0 ${colors.metal_light__9ba9c7};
`;

interface ISectionProps {
  align?: string;
}
const SectionDiv: StyledFunction<ISectionProps & React.HTMLProps<HTMLInputElement>> = styled.div;
const Section = SectionDiv`
  display: inline-flex;
  flex: 1;
  justify-content: ${props => (props.align === 'end' ? 'flex-end' : 'initial')};
  align-items: center;
  min-width: 0;
  height: 100%;
`;

const FollorBase = styled.span`
  width: 100px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  text-align: center;
  cursor: pointer;
`;

const Follow = FollorBase.extend`
  color: ${colors.denim__5fa9ff};

  :hover {
    background-color: ${colors.denim__5fa9ff};
    color: white;
  }
`;

const Unfollow = FollorBase.extend`
  color: ${colors.lava__fe7877};

  :hover {
    background-color: ${colors.lava__fe7877};
    color: white;
  }
`;

@inject('store', 'usecase')
@observer
class OrganizationSetting extends React.Component<IProps, {}> {
  private store: IStore;
  private usecase: IUsecase;

  constructor(props: IProps) {
    super(props);
    this.store = props.store!;
    this.usecase = props.usecase!;
    this.onClick = this.onClick.bind(this);
    this.renderCircularProgress = this.renderCircularProgress.bind(this);
    this.toggleExclusion = this.toggleExclusion.bind(this);
  }

  public render() {
    const { organizationStore, exclusionListStore } = this.store;

    return (
      <Wrapper>
        {organizationStore!.organizations.reverse().map((organization: Organization) => (
          <OrganizationCard key={organization.id}>
            <Section>{organization.username}</Section>
            <Section align="end">
              {exclusionListStore!.updatingOrganizationId === organization.id ? (
                <FollorBase>
                  <CircularProgress size={20} />
                </FollorBase>
              ) : exclusionListStore!.exclusionLists.indexOf(Number(organization.id)) >= 0 ? (
                <Follow onClick={this.onClick} data-id={organization.id}>
                  フォローする
                </Follow>
              ) : (
                <Unfollow onClick={this.onClick} data-id={organization.id}>
                  フォローを外す
                </Unfollow>
              )}
            </Section>
          </OrganizationCard>
        ))}
      </Wrapper>
    );
  }

  private onClick(e: React.MouseEvent<HTMLElement>) {
    const { exclusionListStore } = this.store;
    if (exclusionListStore!.updatingOrganizationId !== '') {
      return;
    }

    const organizationId = e.currentTarget.getAttribute('data-id');
    if (!organizationId) {
      return;
    }
    this.toggleExclusion(organizationId);
  }

  private renderCircularProgress() {
    return (
      <Wrapper>
        <Card>
          <CircularProgressWrapper>
            <CircularProgress size={40} />
          </CircularProgressWrapper>
        </Card>
      </Wrapper>
    );
  }

  private async toggleExclusion(organizationId: string) {
    const { uiState, organizationStore, exclusionListStore } = this.store;
    const { exclusionListUsecase, projectUsecase } = this.usecase;

    const organizations = organizationStore!.organizations.filter(
      (organization: any) => exclusionListStore!.exclusionLists.indexOf(Number(organization.id)) == -1,
    );
    if (organizations.length == 1 && organizations[0].id == organizationId) {
      uiState!.showSnackbar('全組織を除外表示することはできません');
      return;
    }

    await exclusionListUsecase.toggleExclusionList(organizationId);

    // 現在選択している組織が除外されている場合、別組織を選択する
    if (exclusionListStore.exclusionLists.indexOf(Number(organizationId)) >= 0) {
      await organizationStore.setSelectedOrganizationId(organizations[0].id);
      await projectUsecase.getProjects(organizations[0].id);
    }

    uiState.showSnackbar('除外表示設定を切り替えました');
  }
}

export default OrganizationSetting;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/presentation/component/OrganizationSetting.tsx